const modalManageLicensePresetId = (licensePresetId) => {
    return 'msync-org-edit-license-preset-' + licensePresetId
}

const modalCreateLicensePresetId = 'msync-org-create-license-preset'

export{
    modalManageLicensePresetId,
    modalCreateLicensePresetId
  }
